// Typed wrapper over the extracted style index (SPEC §9). v0.2 adds the full
// Style objects; components only ever read styles through this module.

import raw from './generated/styles-index.json';
import type { StyleId, StyleIndexEntry } from './types';

export const STYLES = raw as StyleIndexEntry[];

const byId = new Map(STYLES.map((s) => [s.id, s]));

export function styleName(id: StyleId): string {
  return byId.get(id)?.name ?? id;
}

export const STYLE_GROUPS: { group: StyleIndexEntry['group']; label: string; styles: StyleIndexEntry[] }[] = [
  { group: 'classic', label: 'Classic', styles: STYLES.filter((s) => s.group === 'classic') },
  { group: 'modern', label: 'Modern', styles: STYLES.filter((s) => s.group === 'modern') },
];

/** The style picker sheet's search field: name or subtitle, case-insensitive. Grouped the same as STYLE_GROUPS, empty groups dropped. */
export function searchStyleGroups(query: string): { group: StyleIndexEntry['group']; label: string; styles: StyleIndexEntry[] }[] {
  const q = query.trim().toLowerCase();
  if (!q) return STYLE_GROUPS;
  return STYLE_GROUPS.map((g) => ({ ...g, styles: g.styles.filter((s) => s.name.toLowerCase().includes(q) || s.sub.toLowerCase().includes(q)) })).filter(
    (g) => g.styles.length > 0,
  );
}

/** One style's index entry (name, tempo, crate keywords): the lightweight data the header and Dig read. */
export function styleEntry(id: StyleId): StyleIndexEntry | undefined {
  return byId.get(id);
}
